import type Result from './Result'

import { UserAtom } from '../../../Foobara/Commandforge/Types/User/Atom'

export default function castJsonResult (json: any): Result {
  json = new UserAtom(json)
  return json
}
